import { Autocomplete, TextField } from "@mui/material";
import { Countries } from "app/utils/selection_constants";
import { Controller } from "react-hook-form";
import React from "react";

function FormCountryAutocomplete({
  control,
  name,
  label,
  selectedCountry,
  setSelectedCountry,
  multiple = true,
  required
}) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={selectedCountry}
      rules={{
        required: required
      }}
      render={({ field: { onChange }, fieldState: { error } }) => (
        <Autocomplete
          fullWidth
          sx={{ width: "100%" }}
          options={Countries}
          multiple={multiple}
          value={selectedCountry}
          onChange={(_, data) => {
            onChange(data);
            if (setSelectedCountry) {
              setSelectedCountry(data);
            }
          }}
          getOptionLabel={(option) => option.label || ""}
          isOptionEqualToValue={(option, value) => {
            return option.code === value?.code;
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              placeholder="Select one or more countries"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
            />
          )}
          renderOption={(props, option) => (
            <li {...props} key={option.code}>
              {option.label}
            </li>
          )}
          ListboxProps={{
            style: {
              maxHeight: "200px",
              scrollbarWidth: "thin"
            }
          }}
        />
      )}
    />
  );
}

export default FormCountryAutocomplete;
